/**
 * Iframe messages that carry no user context or handle the iframe session themselves (tss-api #6).
 * Shared by both sides: the parent attaches no token to them, the iframe resolves no session for them.
 */
export const SESSION_FREE_MESSAGES: ReadonlySet<string> = new Set([
  'SDK_AUTH',
  'SDK_CHANNEL_HEARTBEAT',
  'SIGN_IN_START',
  'SIGN_IN_FINISH',
  'SIGN_OUT',
  'GET_SESSION',
  'GET_DAPP_TOKENS',
  'ACCOUNT_REQUEST'
])
